<template>
    <el-card class="occupation-rank-box-diff">
        <el-row>
            <el-col :span="16">
            <img src="../assets/images/occupation_rank.png" alt="收入排行-按行业" class="zyb-img">
            收入排行-按行业
            </el-col>
        </el-row>
        <el-row class="rank-box">
            <el-row v-if="rankStatus == '1'">
                <el-col v-for="index1 in 10" :key="index1">
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="35" width="300">
                        <rect x="0" y="15" width="20" height="25" />
                        <rect x="30" y="15" width="200" height="25" />
                    </ContentLoader>
                </el-col>
            </el-row>
            <div class="no-data-box" v-else-if="rankStatus == '2'">
                <img src="../assets/images/null.png" alt="没有数据">
                <p>暂无数据</p>
            </div>
            <el-row class="rank-list" v-else-if="rankStatus == '3'">
                <el-col v-for="(occupation,index1) in occupationList" :key="index1">
                    <el-row>
                    <el-col :span="2">
                        <div class="rank-number rank-number-top1" v-if="index1 == 0">
                        <img src="../assets/images/rank-top1.png"/>
                        </div>
                        <div class="rank-number rank-number-top2" v-else-if="index1 == 1">
                        <img src="../assets/images/rank-top2.png"/>
                        </div>
                        <div class="rank-number rank-number-top3" v-else-if="index1 == 2">
                        <img src="../assets/images/rank-top3.png"/>
                        </div>
                        <div class="rank-number" v-else>{{index1+1}}</div>
                    </el-col>
                    <el-col :span="17">
                        <h6 :class="index1 < 3 ? 'h6-top2': ''">{{ occupation.name }}</h6>
                    </el-col>
                    <el-col :span="5">
                        <span :class="index1 < 3 ? 'span-top': ''">{{ occupation.salary }}</span>
                    </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-row>
    </el-card>
</template>

<script>
import { getIndustrySalary } from '@/api/occupation'
import { ContentLoader } from 'vue-content-loader'
import { mapState } from 'vuex'

export default {
    components: {
        ContentLoader
    },
    name: "rank",
    data(){
        return {
            rankList: [],
            rankStatus: '1'
        }
    },
    created() {
        this.occupationRankHandler();
    },
    computed: {
        ...mapState({
            token: state => state.user.token,
        }),
    },
    watch: {
        token (newVal) {
            if(newVal != '') {
                this.occupationRankHandler();
            }
        }
    },
    methods: {
        occupationRankHandler() {
            getIndustrySalary().then(res => {
                if(res.data.length == 0) {
                    this.rankStatus = '2';
                    return
                }
                this.rankStatus = '3';
                this.occupationList = res.data;
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .occupation-rank-box-diff {
        margin-bottom: 16px;
    }
    .zyb-img {
        width: 24px;
        height: 24px;
        position: relative;
        top: 4px;
    }
    .el-col-16 {
        color: #2c2e33;
        font-size: 24px;
        font-weight: 600;
    }
    .infor-right {
        text-align: right;
        margin-top: 7px;
        a {
            text-decoration:none;
            color: #999390;
            font-size: 14px;
            text-align: center;
        }
        .el-icon-arrow-right {
            font-size: 14px;
            left: 3px;
            position: relative;
            color: #c4c7cc;
        }
        a:hover {
            color: $common-color;
            .el-icon-arrow-right {
                color: $common-color;
            }
        } 
    }
    .rank-box {
        border-top: 1px solid #f0f2f5;
        margin-top: 14px;
        position: relative;
        .rank-list {
            position: relative;
            .rank-title {
                margin-top: 27px;
                @include gnowrap;
                text-align: left;
            }
            .rank-title:hover {
                color: $common-color;
            }
            > .el-col {
                margin-top: 27px;
            }
        }
        .el-col-5 {
            text-align: right;
            position: relative;
            img {
                width: 12px;
                height: 16px;
                position: absolute;
                top: 1px;
            }
            span {
                margin-left: 18px;
            }
            .span-top {
                color: $common-color1;
            }
        }
        .rank-number {
            width: 18px;
            height: 18px;
            background: #f0f2f5;
            border-radius: 3px;
            font-size: 14px;
            color: #909399;
            font-weight: 600;
            text-align: center;
            line-height: 18px;
            // margin-top: 3px;
        }
        .rank-number-top1,.rank-number-top2,.rank-number-top3 {
            background: none;
            img {
                width: 18px;
                height: 18px;
            }
        }
        h6 {
            font-size: 16px;
            color: #66605e;
            margin: 0;
            font-weight: 400;
        }
        h6:hover {
            color: $common-color;
        }
        .h6-top2 {
            color: $common_color1;
        }
    }
    .no-data-box {
        position: absolute;
        top: 250px;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
            margin-left: -14px;
        }
    }
</style>